/**
 * Plugin "Celada - Pronta Consegna" (celada-my-json-fetcher)
 *
 * Rendering lato client della griglia dello shortcode [pronta_consegna_main]:
 * legge i dati dall'endpoint REST del plugin e riempie #cpc-main.
 * Caricato da inc/enqueue-assets.php solo se il plugin è attivo.
 * Dati passati da PHP in window.celadaProntaConsegna.
 *
 * @package Celada
 */

const { homeUrl: rootUrl, pluginUrl, strings } = window.celadaProntaConsegna || {};

/**
 * Escape HTML entities per prevenire XSS in contesti innerHTML.
 * Copre anche le virgolette: i valori finiscono pure negli attributi (alt, id, aria-label).
 */
function escapeHTML(str) {
	return String(str ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

const placeholderUrl = `${pluginUrl}placeholder/celada-logo.webp`;

/**
 * URL dell'immagine della macchina: il campo "image" dell'endpoint REST
 * (WebP, originale o placeholder, scelto lato server). Senza il campo
 * (plugin non aggiornato) prova la WebP. Se il file non si carica, il
 * listener "error" sul container mostra il placeholder.
 */
function getImageUrl(item) {
	return item.image || `${pluginUrl}data/images/${encodeURIComponent(item.MachineCode)}.webp`;
}

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('cpc-main');
	if (!container || !rootUrl) return;

	document.querySelectorAll('.page-cpc p:empty').forEach((p) => p.remove());
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	window.scrollTo(0, 0);

	// Mostra subito un loader prima di iniziare la fetch
	container.setAttribute('aria-live', 'polite');
	container.setAttribute('aria-busy', 'true');
	container.innerHTML = `
	<div class="loader-wrapper" role="status">
		<span class="loader"></span>
		<span class="loader-copy">${strings.loadingcopy}</span>
	</div>`;

	container.classList.add('page-cpc__grid--message');

	fetch(rootUrl + '/wp-json/my-json/v1/get')
		.then(response => response.json())
		.then(data => {
			let file1 = data.file1;
			let file2 = data.file2;

			// Un blocco HTML per ogni elemento di file1
			return file1.map(item => {
				if (item.nr_of_machine_available <= 0) {
					// Se la macchina non è disponibile, nessun blocco
					return '';
				}

				let machineCode = item.MachineCode;
				let name = item.name.replace(/\s*\(.*$/, '').trim();
				let safeName = escapeHTML(name);
				let safeMachineCode = escapeHTML(machineCode);

				let promo = item.PROMO;
				let isPromoActive = promo === 'TRUE' ? true : false;
				let promoClass = isPromoActive === true ? ' item--promo' : '';

				let imageUrl = getImageUrl(item);

				// Creiamo la stringa HTML
				let listPageUrl = window.location;

				const params = new URLSearchParams();
				params.set('code', machineCode);
				params.set('origin', listPageUrl.href || '');

				let urlDetail = rootUrl + '/dettaglio-macchina/?' + params.toString();

				let title = strings.cta + ' ' + name;
				let safeTitle = escapeHTML(title);

				let singleElementHTML = `
					<div class="item${promoClass}" id="${safeMachineCode}">

						<a href="${escapeHTML(urlDetail)}" aria-label="${safeTitle}" class="item__img-wrapper">
							${isPromoActive ? '<span class="promo-badge">Promo</span>' : ''}
							<figure class="item__figure">
								<img src="${escapeHTML(imageUrl)}" alt="${safeName}" class="item__image" loading="lazy">
							</figure>
						</a>
						<div class="item__content">
							<a href="${escapeHTML(urlDetail)}" aria-label="${safeTitle}"><h3>${safeName}</h3></a>
							<a href="${escapeHTML(urlDetail)}" aria-label="${safeTitle}" class="arrow"></a>
						</div>
					</div>
				`;
				return singleElementHTML;
			});
		})
		.then(htmlBlocks => {
			// Abbiamo tutti i blocchi HTML pronti, li uniamo in un'unica stringa
			let template = htmlBlocks.join('');
			// Sostituiamo il loader con il contenuto generato
			container.classList.remove('page-cpc__grid--message');
			container.removeAttribute('aria-busy');
			container.innerHTML = template || `<p class="no-data">${strings.noData}</p>`;
			// Immagine mancante: placeholder ("error" non fa bubbling, serve la fase di capture)
			container.addEventListener('error', (event) => {
				const img = event.target;
				if (img.tagName === 'IMG' && img.classList.contains('item__image') && !img.src.endsWith(placeholderUrl)) {
					img.src = placeholderUrl;
				}
			}, true);
			// Sposta il focus sul primo elemento interattivo per utenti keyboard/screen reader
			const firstItem = container.querySelector('a, button, [tabindex]');
			if (firstItem) {
				firstItem.focus({ preventScroll: true });
			}
		})
		.catch(err => {
			console.error(err);
			// Se c'è un errore, mostriamo un messaggio di fallback
			container.classList.add('page-cpc__grid--message');
			container.innerHTML = `<p class="no-data">${strings.noDataAtMoment}</p>`;
		});
});
